<template>
    <div class="container">
        <div class="flex-container">
            <div>
                 Copyright © 2019 Xperience Education. All Rights Reserved. All Use Subject to Terms of Use 
            </div>

        </div>
       
    </div>
</template>

<script>
export default {
    "name": "footer-comp",
    setup() {
        
    },
}
</script>

<style lang="scss" scoped>

@import '@/styles/shared.scss';

.container{
    background-color: #383c3f;
    height: 50px;
    color: white;
    font-size: .5rem;

     @media(min-width: $bp-tablet-portrait){
        font-size: .9rem;
    }
}

.flex-container{
    height: 100%;
    display:flex; 
    justify-content: center; 
    align-items: center;
}

</style>